export default "__VITE_ASSET__DpDj71fj__"